import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment-timezone';

import Select from 'react-select';
import { DatePickerInput } from '../DatePickerInput';

import { ChecklistConfigsService } from '../../services';
import i18next from "i18next";

const ChecklistSummaryReportForm = ({ groupingValues, onSubmit }) => {
  const [grouping, setGrouping] = useState(null);
  const [checklistConfig, setChecklistConfig] = useState(null);
  const [startAtDate, setStartAtDate] = useState(null);
  const [loadingChecklists, setLoadingChecklists] = useState(false);
  const [clear, setClear] = useState(false);
  const [availableChecklists, setAvailableChecklists] = useState([]);

  useEffect(() => {
    if (grouping && startAtDate) {
        setLoadingChecklists(true);

        const timezone = grouping.timezone;
        const starting = timezone ? moment(startAtDate).tz(timezone).startOf('day').utc().valueOf() 
                                  : moment(startAtDate).startOf('day').utc().valueOf();
    
        ChecklistConfigsService.getChecklistConfigsForGrouping(grouping.id, starting).then((response) => {
          const selectedAvailable = checklistConfig && response.checklistConfigs.some((config) => config.id === checklistConfig.id);
          const configs = response.checklistConfigs.sort((a, b) => {
                return a.name.localeCompare(b.name);
              }).map((config) => ({ 
                value: config.id, 
                label: `${config.name} (V${config.version})`, 
                config: config 
              }));
          
          setAvailableChecklists(configs);
          setClear(!selectedAvailable);
          setLoadingChecklists(false);
        }).catch(error => {
          console.error(error);
          setLoadingChecklists(false);
        });
      }
  }, [grouping, startAtDate]);

  const doSubmit = useCallback((event) => {
    event.preventDefault(); 
    onSubmit({
      startAtDate: startAtDate,
      checklist: checklistConfig,
      location: grouping
    });
  }, [onSubmit, startAtDate, grouping, checklistConfig]);

  return (
    <div className="op-content-box filter-box" style={{marginBottom: 20}}>
      <form onSubmit={doSubmit}>
        <ul className="list-inline clearfix">
          <li className="pull-left box-label"><h4 className="remove-margin-bottom">{ i18next.t('filters') }</h4></li>
        </ul>

        <div className = "row">
          <div className="col-sm-3">
            <label>{ i18next.t('form-labels.location') }</label>
            <Select
                name={`location`}
                options={groupingValues}
                clearable={false}
                searchable={true}
                classNamePrefix="react-select"
                onChange={(option) => { setGrouping(option.grouping) }}
                placeholder={ i18next.t('form-labels.select-location') }
            />
          </div>

          { grouping &&
            <div>
              <div className="align-date-picker pull-left">
                <label>{ i18next.t('form-labels.start-date') }</label>
                <DatePickerInput
                  input={{value: startAtDate}}
                  meta={{}}
                  onDayChange={setStartAtDate}
                  dayPickerProps={{
                    disabledDays: {daysOfWeek: [1,2,3,4,5,6]}
                  }}
                />
              </div>
            </div>
          }

          { grouping && startAtDate  &&
            <div className="col-sm-3">
              <label>{ i18next.t('form-labels.checklist') }</label>
              <Select
                  name={`checklist`}
                  options={loadingChecklists ? [] : availableChecklists}
                  clear={clear}
                  clearable={false}
                  searchable={true}
                  placeholder={ i18next.t('form-labels.select-checklist') }
                  classNamePrefix="react-select"
                  onChange={(option) => { setChecklistConfig(option.config); setClear(false); }}
                  isLoading={loadingChecklists}
              />
            </div>
          }

          <div className="pull-left">
            <label style={{visibility: 'hidden'}}>{ i18next.t('form-labels.run-report') }</label>
            <ul className="list-inline clearfix">
              <li className="pull-left" style={{marginLeft: '15px'}}>
                <button type="submit" className="btn btn-sm btn-default pull-right" disabled={!(grouping && checklistConfig && startAtDate)} >{ i18next.t('form-labels.run-report') }</button>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  );

};

export default ChecklistSummaryReportForm;
